import React, { useEffect } from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { routes } from "./routeList";
import ProtectedRoute from "./protectesRoute";
import PublicRoute from "./publicRoute";
import { checkIs2026 } from "../utils/functions/common";

const AppRouter = () => {


  const RoutesComponent = () => {

    const location = useLocation();

    useEffect(() => {
      let selectedRoute = routes.find(route => route?.path === window.location.pathname);
      if(!selectedRoute){
        selectedRoute = routes.find(route => `/2026${route?.path}` === window.location.pathname);
      }
      document.title = selectedRoute?.title;
      const is2026 = checkIs2026();
      if(is2026){
        document.body.classList.add('yr-2026');
      }else{
        document.body.classList.remove('yr-2026');
      }
    }, [location?.pathname])
    
    return (
      <Routes>
         {routes.map(({ path, element, protectedRoute, publicRoute }, index) => {
         return  Array.from({length:1}).map((_, index) => {
            const url = path;
            // const url = index === 0 ? `/2025${path}` : path;
            if (protectedRoute) {
            return (
              <Route
                key={index}
                path={url}
                element={
                  <ProtectedRoute>
                    {element}
                  </ProtectedRoute>
                }
              />
            );
          }
          if(publicRoute){
            return (
              <Route
                key={index}
                path={url}
                element={
                  <PublicRoute>
                    {element}
                  </PublicRoute>
                }
              />
            );
          }
          return <Route key={index} path={url} element={element} />;
          })
        })}
      </Routes>
    );
  };

  return (
    <BrowserRouter>
      <RoutesComponent />
    </BrowserRouter>
  );
};

export default AppRouter;